import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import pluralize from 'pluralize';

import { isListingTenantScreening } from 'common/listingHelpers';

import { SCREEN_ID_HOUSEHOLD_ROOMMATE_INVITES_SENT } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ListingActions from 'client/actions/Listing';
import HouseholdActions from 'client/actions/Household';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

import branch from 'client/core/branch';

@withTransitionHook
@withScreenId(SCREEN_ID_HOUSEHOLD_ROOMMATE_INVITES_SENT)
@branch({
  listing: ['listing'],
  roommates: ['roommateApplication', 'roommates'],
  currentUser: ['currentUser'],
  renterProfilesByUserId: ['household', 'renterProfilesByUserId'],
})
@withScrollToTop
class HouseholdRoommateInviteLinksSent extends Component {
  static fetchData(match, inject) {
    return Promise.all([
      ListingActions.getById(inject, parseInt(match.params.listingId, 10)),
      HouseholdActions.loadRenterProfile(inject, {
        userId: parseInt(match.params.userId, 10),
      }),
    ]);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Invite Roommates to Apply | Sunroom Rentals',
    section: 'Invites Links Sent',
  });

  static propTypes = {
    listing: PropTypes.object.isRequired,
  };

  _onOkClick = () => {
    const { listing, dispatch } = this.props;

    dispatch(HouseholdActions.roommateApplicationStep, {
      listingId: listing.id,
    });
  };

  render() {
    const { listing, roommates, currentUser, renterProfilesByUserId } = this.props;

    const renterProfile = renterProfilesByUserId[currentUser.id];

    if (!listing) {
      return <Redirect to="/tour" />;
    }

    return (
      <div className="page-inviteRoommates">
        <div className="modal success">
          <div className="contentContainer">
            <div className="heroIcon peopleGroup" />
            <div className="textContainer">
              <span className="headline">Invite {pluralize('link', roommates.length)} sent!</span>
              <span className="explainer">
                {`We texted your ${pluralize('roommate', roommates.length)} the ` +
                  `${pluralize('link', roommates.length)} to apply.`}
                <br />
                Your application won’t be considered until every roommate has submitted their
                application/fees.
              </span>
            </div>
            <ButtonDeprecated onClick={this._onOkClick}>
              {isListingTenantScreening(listing) && renterProfile.guarantorCount === 0
                ? 'continue'
                : 'next: guarantors'}
            </ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

HouseholdRoommateInviteLinksSent.displayName = 'HouseholdRoommateInviteLinksSent';

export default HouseholdRoommateInviteLinksSent;
